module.exports = __webpack_public_path__ + "static/media/DSC05567.ba4487de.jpg";